import { render } from "./Cadastro.vue?vue&type=template&id=dee02e7e&scoped=true"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"

import "./Cadastro.vue?vue&type=style&index=0&id=dee02e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee02e7e"]])

export default __exports__